import {
  BorderRadius,
  FontWeight,
  SharedValues,
  Sizes,
} from "./themeInterfaces";

export const spacing: Sizes = {
  xs: "8px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "40px",
};

export const lineHeight: Sizes = {
  xs: "16px",
  sm: "20px",
  md: "24px",
  lg: "40px",
  xl: "48px",
};

export const fontSizes: Sizes = {
  xs: "14px",
  sm: "16px",
  md: "18px",
  lg: "24px",
  xl: "32px",
};

export const fontWeight: FontWeight = {
  light: "300",
  regular: "400",
  medium: "400",
  bold: "600",
  extraBold: "800",
};

export const borderRadius: BorderRadius = {
  extraSmallRounding: "2px",
  smallRounding: "4px",
  largeRounding: "16px",
};

export const sharedValues: SharedValues = {
  spacing,
  lineHeight,
  fontSizes,
  fontWeight,
  borderRadius,
  spinner: "primary",
  borderDisabled: `4px solid #cccccc`,
};

export const sharedColors = {
  // black: "#191919",
  black: "var(--p-color-text-primary)",
  white: "#fff",
  gray: "#f1f1f1",
  lightGray: "#f2f2f2",
  stbRed: "#bf0900",
  stbGreen: "#4A966E",
  icons: {
    red: "#AA0600",
    green: "#5F7420",
    white: "#ffffff",
    orange: "#C17B0B",
  },
  surface: {
    main: "var(--color-surface)",
    // variant: "#E8F3E1",
    variant: "var(--p-color-surface-1)",
    hover: "#F4DBB8",
    border: "var(--color-surface-border)",
  },
};
